import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const ArrowLongRight = ({ color, ...props }: IconProps) => {
    return (
        <svg width="43" height="15" viewBox="0 0 43 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M42.2071 8.20711C42.5976 7.81658 42.5976 7.18342 42.2071 6.79289L35.8431 0.428932C35.4526 0.0384078 34.8195 0.0384078 34.4289 0.428932C34.0384 0.819457 34.0384 1.45262 34.4289 1.84315L40.0858 7.5L34.4289 13.1569C34.0384 13.5474 34.0384 14.1805 34.4289 14.5711C34.8195 14.9616 35.4526 14.9616 35.8431 14.5711L42.2071 8.20711ZM0.5 8.5H41.5V6.5H0.5V8.5Z"
                fill={color || "#000"}
            />
        </svg>
    )
}

export default ArrowLongRight
